import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOnCallPolicies as onGetAllOnCallPolicies, deleteSpecificOnCallPolicy as onDeleteSpecificOnCallPolicy } from "../../store/onCallPolicy/actions";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { Link } from 'react-router-dom';
import {
    Badge,
    Card,
    CardBody,
    Table,
    UncontrolledTooltip,
    Row,
    Toast,
    ToastHeader,
    ToastBody,
    Modal,
    ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import './styles.scss';
import { getLocalDateTime } from "../../helpers/component_helpers";

const Policies = props => {
    const dispatch = useDispatch();
    const policies = useSelector((state) => state.onCallPolicy.policies || []);
    const [policiesToDisplay, setPoliciesToDisplay] = useState([]);
    const [policyId,setPolicyId] = useState(null);

    useEffect(() => {
        dispatch(onGetAllOnCallPolicies());
    }, [onGetAllOnCallPolicies]);

    useEffect(() => {
        setPoliciesToDisplay(policies);
    }, [policies]);

    const handleDeleteClick = (id) => {
        dispatch(onDeleteSpecificOnCallPolicy(id));
        setDeleteConfirmationModalIsOpen(false);
    };

    const headers = ['Policy Name', 'Status', 'Number of Escalations', 'Created At', 'Updated At', 'Action'];
    const [showEditToast, setShowEditToast] = useState(false);
    // const [showAddToast, setShowAddToast] = useState(false);

    useEffect(() => {
        // const stateOfAddToast = localStorage.getItem("state_of_add_toast");
        const stateOfEditToast = localStorage.getItem("state_of_edit_toast");
        // if (stateOfAddToast === "true") {
        //     setShowAddToast(true);
        //     hideAddToastAfterDelay();
        // }
        if (stateOfEditToast === "true") {
            setShowEditToast(true);
            hideToastAfterDelay();
        }
    }, []);

    // const closeAddToast = () => {
    //     setShowAddToast(false);
    //     localStorage.setItem("state_of_add_toast", "false");
    //     localStorage.removeItem("state_of_add_toast");
    // };

    // const hideAddToastAfterDelay = () => {
    //     setTimeout(() => {
    //         setShowAddToast(false);
    //         localStorage.setItem("state_of_add_toast", "false");
    //         localStorage.removeItem("state_of_add_toast");
    //     }, 5000);
    // };

    const closeToast = () => {
        setShowEditToast(false);
        localStorage.setItem("state_of_edit_toast", "false");
        localStorage.removeItem("state_of_edit_toast");
    };

    const hideToastAfterDelay = () => {
        setTimeout(() => {
            setShowEditToast(false);
            localStorage.setItem("state_of_edit_toast", "false");
            localStorage.removeItem("state_of_edit_toast");
        }, 5000);
    };
    const [deleteConfirmationModalIsOpen, setDeleteConfirmationModalIsOpen] = useState(false);
    const toggleModal = () => {
        setDeleteConfirmationModalIsOpen(!deleteConfirmationModalIsOpen)
    }
    return (
        <React.Fragment>
            {/* {showAddToast && (
                <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: "1005" }}>
                    <Toast>
                        <ToastHeader toggle={closeAddToast}>
                            SUCCESS!
                        </ToastHeader>
                        <ToastBody>
                            On-Call Policy successfully added.
                        </ToastBody>
                    </Toast>
                </div>
            )} */}
            {showEditToast && (
                <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: "1005" }}>
                    <Toast>
                        <ToastHeader toggle={closeToast}>
                            SUCCESS!
                        </ToastHeader>
                        <ToastBody>
                            On-Call Policy successfully modified.
                        </ToastBody>
                    </Toast>
                </div>
            )}
           
                    <div className="table-card">
                        <Table hover className="table-purple">
                            <thead className="table-light table-nowrap">
                                <tr>
                                    {headers?.map((header, index) => (
                                        <th key={index} style={{ textAlign: 'center' }}>
                                            <div className="mb-2 text-white">
                                                {header}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {policiesToDisplay?.map((policy, index) => {
                                    return (
                                        <Fragment key={index}>
                                            <tr>
                                                <td style={{ textAlign: 'center' }}>
                                                    <Link to={`/oncall-policies/${policy?.id}`}
                                                        className="text-primary">
                                                        {policy?.name}
                                                    </Link>
                                                </td>
                                                <td style={{ textAlign: 'center' }}>
                                                    <Badge className="font-size-13 badge-soft-success">Active</Badge>
                                                </td>
                                                <td style={{ textAlign: 'center' ,color: 'white' }}>
                                                    {policy?.escalation_policy_count}
                                                </td>
                                                <td style={{ textAlign: 'center',color: 'white'}}>
                                                    {policy?.created_at ? getLocalDateTime(policy?.created_at) : '-'}
                                                </td>
                                                <td style={{ textAlign: 'center' ,color: 'white'}}>
                                                    {policy?.updated_at ? getLocalDateTime(policy?.updated_at) : '-'}
                                                </td>
                                                <td className="d-flex gap-3 text-center justify-content-center">
                                                    <Link to={`/oncall-policies/${policy?.id}`}
                                                        className="text-success">
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip className="on-call-tooltip-component" placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                    </Link>
                                                    <i className="mdi mdi-trash-can font-size-18 text-danger" id="deletetooltip" style={{ cursor: 'pointer' }} onClick={() => {
                                                        setPolicyId(policy?.id);
                                                        setDeleteConfirmationModalIsOpen(true);
                                                    }} />
                                                    <UncontrolledTooltip className="on-call-tooltip-component" placement="top" target="deletetooltip">
                                                        Delete
                                                    </UncontrolledTooltip>
                                                </td>
                                            </tr>
                                        </Fragment>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
            <Modal isOpen={deleteConfirmationModalIsOpen} toggle={toggleModal} centered>
                <ModalHeader className="text-white justify-content-center d-flex">
                    Confirm Deletion
                </ModalHeader>
                <ModalBody className="text-center">
                    <p className="mb-4">
                        Are you sure you want to delete this Policy? <br/>
                        <strong>All escalations within this policy will be deleted.</strong>
                    </p>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-center">
                    <button className="btn btn-outline-secondary mx-2" onClick={toggleModal}>
                        Cancel
                    </button>
                    <button className="btn btn-danger mx-2" onClick={() => {handleDeleteClick(policyId)}}>
                        Delete
                    </button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

Policies.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
    onGetServices: PropTypes.func,
};

export default withRouter(Policies);